"use client";

import React from "react";
import { ShieldCheck, Scale, HeartHandshake } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contentBlocks = [{
  title: "Confidentiality",
  description: "Your privacy is our absolute priority. We operate under strict non-disclosure protocols, ensuring that every inquiry, document, and interaction remains completely discreet and secure.",
  icon: ShieldCheck
}, {
  title: "Ethical Framework",
  description: "We adhere to the highest legal and ethical standards in India. Our verification processes are thorough, compliant, and conducted with unwavering integrity, protecting all parties involved.",
  icon: Scale
}, {
  title: "Emotional Intelligence",
  description: "Truth requires sensitivity. We approach every case with deep empathy, understanding the delicate nature of personal relationships and delivering clarity with dignity.",
  icon: HeartHandshake
}];
export default function FoundationsOfTrust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="foundations-of-trust" className="bg-background py-20 lg:py-32 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div className={cn("lg:col-span-7 relative transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}>
            <div className="relative w-full">
              <AspectRatio ratio={4 / 5} className="bg-muted overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554289/img/indian_people_office_laptops.png" alt="Indian people working on laptops in an office setting" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700 ease-in-out" />
              </AspectRatio>
              {}
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-accent -z-10 hidden lg:block" />
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col justify-center">
            <div className="space-y-10">
              {contentBlocks.map((block, index) => <div key={block.title} data-index={index} className={cn("group transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
              transitionDelay: `${index * 200}ms`
            }}>
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-3 mb-1">
                      <block.icon className="w-5 h-5 text-primary/60" />
                      <h3 className="font-serif text-2xl text-foreground tracking-tight">
                        {block.title}
                      </h3>
                    </div>
                    <p className="text-muted-foreground leading-relaxed text-base lg:text-lg font-light">
                      {block.description}
                    </p>
                  </div>
                  {index !== contentBlocks.length - 1 && <Separator className="mt-10 bg-border/60" />}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}